import React from "react";
import { Link } from "react-router-dom";

const LegalLayout = ({ eyebrow, title, updated, children }) => (
  <div className="pt-28 pb-24">
    <div className="max-w-3xl mx-auto px-6 lg:px-10">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/50 hover:text-[#d4af37] transition-colors mb-10"
      >
        ← Till startsidan
      </Link>
      <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37]">
        {eyebrow}
      </span>
      <h1 className="mt-6 font-serif text-4xl md:text-5xl text-white leading-[1.1]">
        {title}
      </h1>
      {updated && (
        <p className="mt-4 text-sm text-white/50">Senast uppdaterad: {updated}</p>
      )}
      <div className="gold-divider my-10" />
      <div className="space-y-8 text-white/75 leading-relaxed">{children}</div>
    </div>
  </div>
);

export default LegalLayout;
